import React from 'react'
import { connect } from 'react-redux'
import { formValueSelector } from 'redux-form'
import { Grid } from 'semantic-ui-react'

import withConstantPermissions from '../../shared/containers/withConstantPermissions'
import FormField from '../../shared/newFormElements'
import StyledFixedHeightContainer from '../components/StyledFixedHeightContainer'
import { getCommercialRateInfo } from '../helpers'
import { RateCheckboxesProps } from './ConvertOnAccountInCash.types'

//@ts-ignore
@withConstantPermissions()
//@ts-ignore
@connect((state, { FormName }) => {
  const formSelector = formValueSelector(FormName)

  return {
    debitCCY: formSelector(state, 'debitCCY'),
    creditCCY: formSelector(state, 'creditCCY'),
    CCYRateType: formSelector(state, 'CCYRateType'),
    buyACheck: formSelector(state, 'buyACheck'),
    sellBCheck: formSelector(state, 'sellBCheck'),
    buyAmountA: formSelector(state, 'buyAmountA'),
    sellAmountB: formSelector(state, 'sellAmountB'),
    alreadyDefinedRates: formSelector(state, 'alreadyDefinedRates'),
    ccyBuyRate: formSelector(state, 'ccyBuyRate'),
    ccySellRate: formSelector(state, 'ccySellRate'),
  }
})
class RateCheckboxes extends React.Component<RateCheckboxesProps> {
  componentDidUpdate(prevProps: RateCheckboxesProps) {
    const {
      alreadyDefinedRates,
      debitCCY,
      creditCCY,
      CCYRateType,
      CCYOfficalRates,
      buyAmountA,
      sellAmountB,
      change,
      ccyBuyRate,
      ccySellRate,
    } = this.props

    if (
      (parseFloat(buyAmountA) !== parseFloat(prevProps.buyAmountA) ||
        parseFloat(sellAmountB) !== parseFloat(prevProps.sellAmountB)) &&
      alreadyDefinedRates === '0'
    ) {
      if (parseFloat(buyAmountA) && parseFloat(sellAmountB)) {
        //@ts-ignore
        change('ccyBuyRate', sellAmountB / buyAmountA)
        //@ts-ignore
        change('ccySellRate', buyAmountA / sellAmountB)
      } else if (!(parseFloat(ccyBuyRate) === 0 && parseFloat(ccySellRate) === 0)) {
        change('ccyBuyRate', 1)
        change('ccySellRate', 1)
      }
    }

    if (alreadyDefinedRates !== prevProps.alreadyDefinedRates && alreadyDefinedRates === '0') {
      change('buyACheck', '1')
      change('sellBCheck', '1')

      if (parseFloat(buyAmountA) && parseFloat(sellAmountB)) {
        //@ts-ignore
        change('ccyBuyRate', sellAmountB / buyAmountA)
        //@ts-ignore
        change('ccySellRate', buyAmountA / sellAmountB)
      } else if (!(parseFloat(ccyBuyRate) === 0 && parseFloat(ccySellRate) === 0)) {
        change('ccyBuyRate', 1)
        change('ccySellRate', 1)
      }
    }

    if (alreadyDefinedRates !== prevProps.alreadyDefinedRates && alreadyDefinedRates === '1') {
      change('buyACheck', '1')
      change('sellBCheck', '0')
    }

    if (CCYRateType !== prevProps.CCYRateType || debitCCY !== prevProps.debitCCY || creditCCY !== prevProps.creditCCY) {
      if (CCYRateType === 'offical') {
        const ccyToChoose = creditCCY === 'GEL' ? debitCCY : creditCCY
        const sellCCY = CCYOfficalRates.find((curr) => curr.CCY === ccyToChoose) || {}
        //@ts-ignore
        const sellCCYRate = sellCCY.OffRate

        if (!sellCCYRate && (debitCCY === 'GEL' || creditCCY === 'GEL')) {
          change('ccyOfficalRateNotFound', true)
        } else {
          change('ccyOfficalRateNotFound', false)

          let topCCYRate
          let bottomCCYRate

          if (debitCCY === 'GEL') {
            topCCYRate = sellCCYRate || 1
            //@ts-ignore
            bottomCCYRate = sellCCYRate ? parseFloat(1 / sellCCYRate).toFixed(15) : 1
          } else {
            //@ts-ignore
            topCCYRate = sellCCYRate ? parseFloat(1 / sellCCYRate).toFixed(15) : 1
            bottomCCYRate = sellCCYRate || 1
          }

          change('ccySellRate', topCCYRate)
          change('ccyBuyRate', bottomCCYRate)
        }
      } else {
        this.changeCommercialRates(debitCCY, creditCCY, prevProps)
      }
    }
  }

  changeCommercialRates = (debitCCY: string, creditCCY: string, props: RateCheckboxesProps) => {
    const { change, buyACheck, sellBCheck, CCYCommercialRates } = props

    let ccyRateInfo1 = getCommercialRateInfo(CCYCommercialRates, debitCCY, creditCCY)
    let ccyRateInfo2 = getCommercialRateInfo(CCYCommercialRates, creditCCY, debitCCY)

    change('ccyCommercialRateNotFound', !ccyRateInfo1 || !ccyRateInfo2)

    ccyRateInfo1 = ccyRateInfo1 || { RateBuy: 1, RateSell: 1 }
    ccyRateInfo2 = ccyRateInfo2 || { RateBuy: 1, RateSell: 1 }

    if ((buyACheck === '1' && sellBCheck === '0') || (buyACheck === '0' && sellBCheck === '1')) {
      change('ccyBuyRate', ccyRateInfo2.RateBuy)
      change('ccySellRate', ccyRateInfo1.RateSell)
    }
  }

  render() {
    const { debitCCY, alreadyDefinedRates, disabled, permissions } = this.props
    return (
      <>
        <Grid.Column textAlign="right" width={1} verticalAlign={debitCCY === 'GEL' ? 'bottom' : 'top'}>
          <StyledFixedHeightContainer className="u-flexCenter">
            {/* @ts-ignore */}
            <FormField
              disabled={!permissions.AUTHORIZE_NONSTANDARD_CONVERSION || disabled}
              name="alreadyDefinedRates"
              type="checkbox"
            />
          </StyledFixedHeightContainer>
        </Grid.Column>

        <Grid.Column width={2}>
          {/* @ts-ignore */}
          <FormField
            format
            scale={4}
            disabled={alreadyDefinedRates !== '1' || debitCCY === 'GEL' || disabled}
            style={{ marginBottom: 5 }}
            type="float"
            name="ccyBuyRate"
            customOnChange={(value: string) => {
              //@ts-ignore
              this.props.change('ccySellRate', parseFloat(value) ? parseFloat(1 / value).toFixed(15) : 0)
            }}
          />
          {/* @ts-ignore */}
          <FormField
            format
            scale={4}
            disabled={alreadyDefinedRates !== '1' || debitCCY !== 'GEL' || disabled}
            type="float"
            name="ccySellRate"
            customOnChange={(value: string) => {
              //@ts-ignore
              this.props.change('ccyBuyRate', parseFloat(value) ? parseFloat(1 / value).toFixed(15) : 0)
            }}
          />
        </Grid.Column>
      </>
    )
  }
}

export default RateCheckboxes
